import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { localizedPath } from '../utils/routes';
import axios from 'axios';
import SEOHead from '../components/SEOHead';

const API = process.env.REACT_APP_API_URL || '/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [state, setState] = useState('form'); // form | success | verifyFirst
  const { t, language } = useLanguage();
  const { lang } = useParams();
  const currentLang = lang || language;
  const lp = (routeName) => localizedPath(routeName, currentLang);
  const fp = t.forgotPassword;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/forgot-password`, { email });
      if (data.requiresVerification) {
        setState('verifyFirst');
      } else {
        setState('success');
      }
    } catch (err) {
      setError(fp.error);
    } finally { setLoading(false); }
  };

  const inputStyle = {
    width: '100%', background: '#1a2332', border: '1px solid rgba(148,163,184,0.2)',
    color: '#E8ECF0', padding: '0.9rem 1rem', fontSize: '0.85rem',
    fontFamily: "'Barlow', sans-serif", outline: 'none',
    transition: 'border-color 0.3s', boxSizing: 'border-box',
  };

  return (
    <div style={{ background: '#0C1220', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <SEOHead page="login" />
      <div style={{ width: '100%', maxWidth: '440px' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: '2rem', color: '#D42B2B', marginBottom: '0.3rem' }}>CJPA</div>
          <div style={{ fontSize: '0.58rem', letterSpacing: '0.1em', color: '#64748B', textTransform: 'uppercase' }}>Mécanique Auto</div>
          <h1 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: '2.2rem', color: '#E8ECF0', fontWeight: 300, marginTop: '2rem' }}>{fp.title}</h1>
          <p style={{ color: '#94A3B8', fontSize: '0.78rem', marginTop: '0.5rem', letterSpacing: '0.05em' }}>{fp.subtitle}</p>
        </div>

        <div style={{ background: '#111827', border: '1px solid rgba(148,163,184,0.15)', padding: 'clamp(1.5rem, 3vw, 2.5rem)' }}>
          {state === 'form' && (
            <>
              {error && <div style={{ background: 'rgba(180,50,50,0.1)', border: '1px solid rgba(180,50,50,0.3)', color: '#e08080', padding: '0.8rem 1rem', fontSize: '0.78rem', marginBottom: '1.5rem', letterSpacing: '0.05em' }}>{error}</div>}

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{ display: 'block', fontSize: '0.6rem', letterSpacing: '0.1em', color: '#64748B', textTransform: 'uppercase', marginBottom: '0.6rem', fontFamily: "'Barlow', sans-serif" }}>{fp.emailLabel}</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                    required style={inputStyle}
                    onFocus={e => e.target.style.borderColor = '#D42B2B'}
                    onBlur={e => e.target.style.borderColor = 'rgba(148,163,184,0.2)'}
                  />
                </div>

                <button type="submit" disabled={loading} style={{
                  width: '100%', background: '#D42B2B', color: '#0C1220', border: 'none',
                  padding: '1rem', fontFamily: "'Barlow', sans-serif", fontSize: '0.65rem',
                  letterSpacing: '0.1em', textTransform: 'uppercase', fontWeight: 600,
                  cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1,
                  marginTop: '0.5rem',
                }}>{loading ? fp.sending : fp.button}</button>
              </form>
            </>
          )}

          {state === 'success' && (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>&#9993;</div>
              <h2 style={{ fontFamily: "'Rajdhani', sans-serif", color: '#E8ECF0', fontWeight: 500, fontSize: '1.3rem', marginBottom: '0.8rem' }}>{fp.successTitle}</h2>
              <p style={{ color: '#94A3B8', fontSize: '0.82rem', lineHeight: 1.6 }}>{fp.successMessage}</p>
            </div>
          )}

          {state === 'verifyFirst' && (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>&#9888;</div>
              <h2 style={{ fontFamily: "'Rajdhani', sans-serif", color: '#E8ECF0', fontWeight: 500, fontSize: '1.3rem', marginBottom: '0.8rem' }}>{fp.verifyFirst}</h2>
              <p style={{ color: '#94A3B8', fontSize: '0.82rem', lineHeight: 1.6 }}>{fp.verifyMessage}</p>
            </div>
          )}

          <div style={{ textAlign: 'center', marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(148,163,184,0.1)' }}>
            <Link to={lp('login')} style={{ color: '#D42B2B', fontSize: '0.78rem', textDecoration: 'none', letterSpacing: '0.05em' }}>{fp.backToLogin}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
